import React, { FC } from 'react';
import API from 'core/Api';
import { useTranslation } from 'react-i18next';
import { useModal } from 'store/modal';
import { useForm } from 'react-hook-form';
import { FaDownload } from 'react-icons/fa';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';
import Button from 'components/Button';
import { createErrorFromResponse } from 'core/Error';
import InnerWrapper from '../../InnerWrapper';

interface IInputs {
  file: File;
}

const Screen: FC = () => {
  const { t } = useTranslation();
  const { showModal } = useModal();

  const methods = useForm<IInputs>();

  const downloadTemplate = () => {
    return API.get('users/export-employees')
      .then(res => {
        window.open(res.data, '_blank');
      })
      .catch(res => {
        const error = createErrorFromResponse(res);
        showModal({
          type: 'error',
          content: error.message,
        });
      });
  };

  return (
    <InnerWrapper>
      <h3 className="h5 mb-4">{t('structure.employees.importTitle')}</h3>
      <div className="mb-4">
        <Button
          btnType="secondary"
          onClick={downloadTemplate}
        >
          <FaDownload className="mr-2" />
          {t('common.downloadTemplate')}
        </Button>
      </div>
      <Row>
        <Col
          md="12"
          lg="6"
        >
          <Form
            methods={methods}
            btnLabel={t('common.save')}
            hideAllBtns
          >
            <FormGroup
              controlId="formGroupFileUpload"
              type="file"
              placeholder={t('fileUploader.placeholder')}
              name="employees"
              isRequired
              uploadUri="users/import-employees"
              accept={['.xls', '.xlsx']}
              hint={t('fileUploader.hint', { accept: 'xls, xlsx' })}
              isImport
            />
          </Form>
        </Col>
      </Row>
    </InnerWrapper>
  );
};

export default Screen;
